import React, { useRef, useEffect } from 'react';
import { TextField } from '@mui/material';

interface Props {
  value: string;
  onChange: (value: string) => void;
  setFormValues : any;
}

const BusinessLocationAutocomplete: React.FC<Props> = ({ value, onChange, setFormValues }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (
      !window.google?.maps?.places ||
      !inputRef.current
    ) {
      console.warn('Google Maps API not loaded yet');
      return;
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (!wrapperRef.current) return;
  
      if (inputRef.current && inputRef.current.contains(event.target as Node)) {
        return;
      }
  
      if (!wrapperRef.current.contains(event.target as Node)) {
        // Clicked outside the whole form
         
      } else {
        // Clicked somewhere else inside the form (but outside input)
        // Simulate selecting the first autocomplete option
        const downEvent = new KeyboardEvent('keydown', { key: 'ArrowDown' });
        inputRef.current?.dispatchEvent(downEvent);
  
        setTimeout(() => {
          const enterEvent = new KeyboardEvent('keydown', { key: 'Enter' });
          inputRef.current?.dispatchEvent(enterEvent);
        }, 100);
      }
    };

    // Clear previous autocomplete instance if any
    const input = inputRef.current;

    const autocomplete = new window.google.maps.places.Autocomplete(input, {
      types: ['geocode'],
      fields: ['formatted_address'],
      //componentRestrictions: { country: 'gb' }
    });

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (place.formatted_address) {
        onChange(place.formatted_address);
      }
    });

    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setFormValues, onChange]);

  return (
    <div ref={wrapperRef}>
      <TextField
        fullWidth
        inputRef={inputRef}
        variant="outlined"
        placeholder="Search address"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default BusinessLocationAutocomplete;
